// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","expertiseFormSection":"_52HgQQA8hD_hjNXJL_6zB","expertiseFormSectionTitle":"_39lKsSqhXae-WjCaES19zu"};